import { Box, Typography } from "@mui/material";
import { memo } from "react";

interface EventPageTitleProps {
  title: string;
}

const EventPageTitle = ({ title }: EventPageTitleProps): JSX.Element => {
  return (
    <Box
      sx={{ display: "flex", justifyContent: "space-between", gap: "0.5em" }}
    >
      <Typography variant="h3">{title}</Typography>
    </Box>
  );
};

export default memo(EventPageTitle);
